<div class="content fleet" style="z-index: 1 !important;">
    <div class="panel panel-flat panel-oncore">
        <div class="panel-heading">
            <div class="report-filter">
                <div class="form-group form-report">
                    <label for="report_type">Report Type</label>
                    <select class="form-control selection-report" data-width="100%" placeholder="Report Type" id="report_type" [(ngModel)]="reportType">
                        <option value="">Select Report</option>
                        <option *ngFor="let key of objectKeys(reportOptions)">{{ reportOptions[key] }}</option>
                    </select>
                </div>
                <div class="form-group form-report" *ngIf="reportType == reportOptions.fMovement">
                    <label for="vehicle_filter">Vehicle Groups</label>
                    <select class="form-control selection-report" data-width="100%" placeholder="Vehicle List" id="vehicle_filter" [(ngModel)]="vehicleFilter" (change)="redeclareVehicleSelection(vehicleFilter)">
                        <optgroup label="Groups">
                            <option *ngFor="let group of vehicleGroups">{{ group }}</option>
                        </optgroup>
                        <optgroup label="Vehicle Status">
                            <option *ngFor="let status of vehicleStatusGroups">{{ status }}</option>
                        </optgroup>
                    </select>
                </div>
                <div class="form-group form-report" [ngClass]="{'force-hide': (userObj?.source == 'bsj' || userObj?.source == 'tracksolid') || (userObj?.source == 'oncore' && reportType != reportOptions.fMovement && reportType != reportOptions.fDriving && reportType != reportOptions.fPark && reportType != reportOptions.genCert)}">
                    <label for="vehicle_list">Vehicles</label>
                    <select class="form-control selection-report js-example-basic-single" data-width="100%" placeholder="Vehicles" id="vehicle_list_oncore" [(ngModel)]="vehicleList">
                        <option value="" *ngIf="userObj?.source == 'oncore'">Select Vehicle</option>
                        <option *ngFor="let key of objectKeys(selectionVehicle)" [value]="selectionVehicle[key].unitId">{{ selectionVehicle[key].plate }}</option>
                    </select>
                </div>
                <div class="form-group form-report" [ngClass]="{'force-hide': userObj?.source == 'oncore' || ((userObj?.source == 'bsj' || userObj?.source == 'tracksolid') && reportType != reportOptions.fDriving && reportType != reportOptions.fPark)}">
                    <label for="vehicle_list">Vehicles</label>
                    <select class="form-control selection-report js-example-basic-multiple" data-width="100%" placeholder="Vehicles" id="vehicle_list_bsj_multi" [(ngModel)]="vehicleList" multiple>
                        <option value="" *ngIf="userObj?.source == 'oncore'">Select Vehicle</option>
                        <option *ngFor="let key of objectKeys(selectionVehicle)" [value]="selectionVehicle[key].unitId">{{ selectionVehicle[key].plate }}</option>
                    </select>
                </div>
                <div class="form-group form-report" [ngClass]="{'force-hide': userObj?.source == 'oncore' || ((userObj?.source == 'bsj' || userObj?.source == 'tracksolid') && reportType != reportOptions.fMovement && reportType != reportOptions.genCert)}">
                    <label for="vehicle_list">Vehicles</label>
                    <select class="form-control selection-report js-example-basic-single" data-width="100%" placeholder="Vehicles" id="vehicle_list_bsj_single" [(ngModel)]="vehicleListBsj">
                        <option value="" >Select Vehicle</option>
                        <option *ngFor="let key of objectKeys(selectionVehicle)" [value]="selectionVehicle[key].unitId">{{ selectionVehicle[key].plate }}</option>
                    </select>
                </div>
                <div class="form-group form-inline full-label no-flex" *ngIf="reportType != reportOptions.genCert">
                    <label for="date_st">Start DateTime</label>
                    <input type="date" class="form-control partial-float" id="date_st" [(ngModel)]="dateStart">
                    <input type="time" class="form-control partial-float-time" id="time_st" [(ngModel)]="timeStart">
                </div>
                <div class="form-group form-inline full-label no-flex" *ngIf="reportType != reportOptions.genCert">
                    <label for="date_nd">End DateTime</label>
                    <input type="date" class="form-control partial-float" id="date_nd" [(ngModel)]="dateEnd">
                    <input type="time" class="form-control partial-float-time" id="time_nd" [(ngModel)]="timeEnd">
                </div>
                <div class="form-group form-report" *ngIf="reportType == reportOptions.fMovement">
                    <label for="event_type">Event</label>
                    <select multiple class="form-control selection-report" data-width="100%" placeholder="Event" id="fmov_event_type" [(ngModel)]="mvEventType" (click)="checkIfClick(mvEventType)">
                        <option value="all">All</option>
                        <option [value]="key" [selected]="selAll" *ngFor="let key of objectKeys(fMovReportTypes)">{{ fMovReportTypes[key] }}</option>
                    </select>
                </div>
                <div class="form-group form-report" *ngIf="reportType == reportOptions.fMovement">
                    <label for="event_type">Time Event Interval</label>
                    <select class="form-control selection-report" data-width="100%" placeholder="Time Interval" id="time_interval" [(ngModel)]="timeInterval">
                        <option value="all">All</option>
                        <option [value]="tInvl" *ngFor="let tInvl of timeIntvl">{{ tInvl }}</option>
                    </select>
                </div>
                <!-- <div class="form-group form-report" *ngIf="reportType == reportOptions.fMovement">
                    <label for="loc_pref">Location Preference</label><br>
                    <input type="radio" name="location_preference" [(ngModel)]="locationPreference" value="0"> Address  
                    <input type="radio" name="location_preference" [(ngModel)]="locationPreference" value="1"> Coordinate
                </div> -->
                <div class="form-group form-inline full-label no-flex">
                    <button type="submit" class="btn btn-default reportGen" (click)="clickEvent()">Submit</button>
                </div>
            </div>
        </div>
        <!--<div class="panel-heading" ng-show="processingSummary == true">
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i>
        </div>-->
        <table id="oncore2" class="display table res-core" cellspacing="0" width="100%"></table>
        <table id="oncore2b" class="display table res-core" cellspacing="0" width="100%"></table>
        <table id="oncore2c" class="display table res-core" cellspacing="0" width="100%"></table>
        <table id="oncore2d" class="display table res-core" cellspacing="0" width="100%"></table>
        <table id="oncore2e" class="display table res-core" cellspacing="0" width="100%"></table>
        <table id="oncore2f" class="display table res-core" cellspacing="0" width="100%"></table>
        <table id="oncore2g" class="display table res-core" cellspacing="0" width="100%"></table>
        <table id="oncore2h" class="display table res-core" cellspacing="0" width="100%"></table>
        <div class="panel-heading" *ngIf="processingDetail == true">
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i>
        </div>
        <table id="oncore3" class="display table " cellspacing="0" width="100%"></table>
    </div>
</div>
<div class="modal fade" tabindex="-1" role="dialog" id="disp-coord">
    <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
			<div class="modal-header bg-light p-3" style="padding-bottom: 0px;">
                <h5 class="modal-title" id="exampleModalLabel" style="width: 85%;float: left;">Address Detail</h5>
				<button (click)="closeModalBtn()" type="button" class="btn btn-close" id="close-modal"> X </button>
			</div>
            <div class="modal-body pt-1">
				<div class="row mb-4">
					<p>
				</div>
                <div class="row mb-4">
					<div class="row">
						<div class="col-md-12">
							<div class="form-group">
                                <p class="mdb-5" style="margin-bottom:8px;"><strong><i style="font-size:15px;" class="fa fa-map-marker" title="Coordinate" aria-hidden="true"></i>&nbsp;&nbsp;:</strong> {{ coordRpt }}</p>
								<p class="mdb-5" style="margin-bottom:8px;"><strong><i style="font-size:15px;" class="fa fa-globe" title="Address" aria-hidden="true"></i>&nbsp;&nbsp;:</strong> {{ addressRpt }}</p>
							</div>
                            <a href="https://www.google.com/maps?q={{coordRpt}}" target="_blank"><button class="btn btn-info" style="width: 100%;" type="button" >View on Map</button></a>
						</div>
					</div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-backdrop fade" id="dispCoordBackdrop"></div>
<div class="modal fade" tabindex="-1" role="dialog" id="fieldOpt">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-body pt-3">
				<div class="row mb-4">
					<div class="col-md-12">
                        <div class="form-group mb-1">
                            <label for="date_st">Chassis No.</label>
                            <input type="text" class="form-control" [(ngModel)]="chasisNo">
                        </div>
                        <div class="form-group mb-1">
                            <label for="date_st">Dealer Name</label>
                            <input type="text" class="form-control" [(ngModel)]="dealerName">
                        </div>
                        <div class="form-group mb-1">
                            <label for="date_st">Dealer Address</label>
                            <textarea class="form-control" [(ngModel)]="dealerAddress" cols="3"></textarea>
                        </div>
                        <div class="form-group mb-1">
                            <label for="date_st">Installation Date</label>
                            <input type="date" class="form-control" [(ngModel)]="installDate">
                        </div>
                        <div class="form-group mb-1" *ngIf="userObj?.source != 'bsj'">
                            <label for="date_st">Activation Date</label>
                            <input type="date" class="form-control" (change)="addYear()" [(ngModel)]="activationDate">
                        </div>
                        <div class="form-group mb-1" *ngIf="userObj?.source != 'bsj'">
                            <label for="date_st">Expiry Date</label>
                            <input type="date" class="form-control" [(ngModel)]="expiryDate">
                        </div>
                        <div class="form-group mb-1">
                            <label for="date_st">Issue Date</label>
                            <input type="date" class="form-control" [(ngModel)]="issueDate">
                        </div>
					</div>
				</div>
                <div class="row mb-4">
					<div class="row">
						<div class="col-md-12">
						</div>
					</div>
                </div>
				<div class="row" style="display: flex;justify-content: flex-end;">
                    <button type="button"  class="btn  btn-default mr-5" (click)="cancelCert()">Cancel</button>
                    <button type="button"  class="btn  btn-primary" (click)="generateCert(certGenerateVehicle)">Save</button>
				</div>
            </div>
        </div>
    </div>
</div>
<div class="modal-backdrop fade" id="fieldOptBackdrop"></div>